import "./src/styles/global.styl"

// SW
export const onServiceWorkerUpdateReady = () => {
    window.location.reload()
}
